import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { styled } from "@mui/material/styles";
import TablePagination from "@mui/material/TablePagination";
import { useTranslation } from "react-i18next";
import { convertEpochToDate } from "@egovernments/digit-ui-module-pt/src/utils";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableRow: {
    backgroundColor: "#1F4A7C",
    color: "#fff",
  },
  tableCell: {
    backgroundColor: "#f2f2f2",
    padding: "10px",
    fontWeight: "bold",
    border: "1px solid #ddd",
  },
  blueText: {
    color: "#1F4A7C",
  },
});

const headerData = [
  { serialNo: "Sl. No" },
  { applicationnumber: "Application No." },
  { permitNumber: "Building Permit No." },
  { developmentAuthorityName: "Authority Name" },
  { modulename: "Module Name" },
  { ownerName: "Owner Name" },
  { ownermobileno: "Owner Mobile No." },
  { commAdd: "Communication Address" },
  { siteAddress: "Site Address" },
  { schemeName: "Scheme Name" },
  { status: "Status" },
  { risk: "Risk Type" },
  { plosUse: "PLOS Use" },
  { ltpName: "LTP Name" },
  { ltpMobilenumber: "LTP Mobile No." },
  { plotArea: "Plot Area" },
  { totalBuiltupArea: "Total Built-up Area" },
  { buildingHeigh: "Building Height" },
  { totalFees: "Total Fees" },
  { totalFeeRec: "Total Fee Received" },
  { totalFeesDue: "Total Fees Due" },
  { submissiondate: "Submission Date" },
  { approvalDate: "Approval Date" },
  { siteInspectionFeesAmount: "Site Inspection Fees" },
  { stackingChargesAmount: "Stacking Charges" },
  { strengtheningChargesAmount: "Strengthening Charges" },
  { waterChargesAmount: "Water Charges" },
  { buildingPermissionFeesAmount: "Building Permission Fees" },
  { buildingPermitFeesAmount: "Building Permit Fees" },
  { specialAmenitiesChargesAmount: "Special Amenities Charges" },
  { labourCessAmount: "Labour Cess" },
  { securityDepositChargesforTreePlantationAmount: "Security Deposit (Tree Plantation)" },
  { securityDepositchargesforRainWaterHarvestingAmount: "Security Deposit (Rain Water Harvesting)" },
  { securityDepositchargesforSolarEnergyAmount: "Security Deposit (Solar Energy)" },
  { amalgamationChargesAmount: "Amalgamation Charges" },
  { bandhaChargesAmount: "Bandha Charges" },
  { bettermentChargesAmount: "Betterment Charges" },
  { cityDevelopmentChargesAmount: "City Development Charges" },
  { compoundingChargesAmount: "Compounding Charges" },
  { developmentFeeAmount: "Development Fee" },
  { developmentPermitFeeAmount: "Development Permit Fee" },
  { gstAmount: "GST Amount" },
  { impactFeeAmount: "Impact Fee" },
  { licenseFeeforIntegratedTownshipAmount: "Integrated Township License Fee" },
  { maintenanceChargesAmount: "Maintenance Charges" },
  { melaShulkAmount: "Mela Shulk" },
  { purchasableFARChargesAmount: "Purchasable FAR Charges" },
  { sewerChargesAmount: "Sewer Charges" },
  { shelterfeesAmount: "Shelter Fees" },
  { subdivisionChargesAmount: "Subdivision Charges" },
  { villageDevelopmentChargesAmount: "Village Development Charges" },
  { surplusAmountAmount: "Surplus Amount" },
  { securityDepositChargesforMechanicalParkingAmount: "Security Deposit (Mechanical Parking)" },
  { mapRateFeesAmount: "Map Rate Fees" },
];
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const InboxTable = ({ apiData }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = React.useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <Paper sx={{ overflow: "hidden", marginY: 2 }}>
      <TableContainer>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow className={classes.tableRow}>
              {headerData.map((item) => (
                <TableCell key={Object.values(item)[0]}>{Object.values(item)[0]}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody style={{ backgroundColor: "#fbfaff" }}>
            {apiData &&
              apiData?.MisAllExtractData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                <StyledTableRow key={row.serialNo}>
                  <StyledTableCell>{index + 1 + page * rowsPerPage}</StyledTableCell>
                  <StyledTableCell>{row?.applicationnumber || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.permitNumber || "-"}</StyledTableCell>
                  <StyledTableCell>{row?.developmentAuthorityName || "N/A"}</StyledTableCell>
                  <StyledTableCell>{t(`${row?.modulename}`) || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.ownerName || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.ownermobileno || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.commAdd || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.siteAddress || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.schemeName || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.status || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.risk || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.plosUse || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.ltpName || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.ltpMobilenumber || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.plotArea || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.totalBuiltupArea || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.buildingHeigh || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.totalFees || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.totalFeeRec || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.totalFeesDue || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.submissiondate || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.approvalDate || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.siteInspectionFeesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.stackingChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.strengtheningChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.waterChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.buildingPermissionFeesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.buildingPermitFeesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.specialAmenitiesChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.labourCessAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.securityDepositChargesforTreePlantationAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.securityDepositchargesforRainWaterHarvestingAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.securityDepositchargesforSolarEnergyAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.amalgamationChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.bandhaChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.bettermentChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.cityDevelopmentChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.compoundingChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.developmentFeeAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.developmentPermitFeeAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.gstAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.impactFeeAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.licenseFeeforIntegratedTownshipAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.maintenanceChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.melaShulkAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.purchasableFARChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.sewerChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.shelterfeesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.subdivisionChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.villageDevelopmentChargesAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.surplusAmountAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.securityDepositChargesforMechanicalParkingAmount || "0"}</StyledTableCell>
                  <StyledTableCell>{row?.mapRateFeesAmount || "0"}</StyledTableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 75, 100]}
        component="div"
        count={apiData?.MisAllExtractData?.length || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default InboxTable;
